import React, { useCallback, useState } from 'react';

// Components
import { WpForm, WpFormLayout } from '..';
import WpTextField from '../../text-field/WpTextField';
import { WpButton } from '../../button';
import WpSelect from '../../select/WpSelect';
import { WpRadioGroup, WpRadioInput } from '../../radio';

const SelectExample = () => {
  const [selected, setSelected] = useState('');

  const handleSelected = value => {
    setSelected(value);
    alert(`selected: ${value}`);
  };
  return (
    <>
      <h3>Select Example</h3>
      <WpSelect
        id="select_example"
        helpText="help text here"
        label="Select Example"
        placeholder="Make a selection"
        value={selected}
        onChange={handleSelected}
        options={['one', 'two', 'three']}
      />
    </>
  );
};

const FormsDocs = () => {
  const FormExample = () => {
    const handleSubmit = useCallback(data => {
      console.log('submitted data: ', data);
      alert('submitted, see console.log for returned data');
    }, []);

    return (
      <>
        <h3>Form Example</h3>
        <WpForm onSubmit={handleSubmit}>
          <WpFormLayout>
            <WpSelect
              id="select_example"
              helpText="help text here"
              label="Select Example"
              placeholder="Select Option"
              value="mr"
              options={[
                { value: 'mr', label: 'Mr.' },
                { value: 'mrs', label: 'Mrs.' },
              ]}
              required
            />
            <WpRadioGroup id="role_input" label="Radio Example" direction="horizontal" required>
              <WpRadioInput id="manager" label="Manager" value="manager" descriptionText="I'm a Manager" />
              <WpRadioInput
                id="direct_report"
                label="Direct Report"
                value="direct_report"
                descriptionText="I'm a Direct Report"
              />
            </WpRadioGroup>
            <WpFormLayout direction="horizontal">
              <WpTextField
                id="name_input"
                type="text"
                label="First Name"
                placeholder=""
                value="Johnny"
                required
                labelIcon="question-circle"
                labelTooltipText="first name is needed"
              />
              <WpTextField id="midde_input" type="text" label="Middle Name" placeholder="" />
              <WpTextField id="last_input" type="text" label="Last Name" placeholder="" required />
            </WpFormLayout>
            <WpTextField
              id="email_input"
              type="text"
              label="Email"
              placeholder="example@domain.com"
              helpText="You'll use this email to login."
              required
            />
            <WpTextField id="message_input" type="text" label="Message" multiline placeholder="" required />
          </WpFormLayout>
          <WpButton btnType="submit">submit</WpButton>
        </WpForm>
      </>
    );
  };

  const CopyPasteInputExample = () => {
    return (
      <>
        <h3>With Copy to clipboard option</h3>
        <WpTextField
          id="copy-paste"
          type="password"
          label="API Token"
          value="this-is-my-super-duper-secret-api-token-that-is-hidden"
          disabled
          enableCopy
        />
      </>
    );
  };

  const RadioInput = () => {
    return (
      <>
        <h3>Radio Input</h3>
        <WpRadioInput
          id="radio_input1"
          name="radio_name1"
          label="Radio Example"
          value="Radio Input Example"
          descriptionText="descriptionText for radio input"
        />
        <WpRadioInput
          id="radio_input2"
          name="radio_name1"
          label="Radio Example"
          value="Radio Input Example"
          descriptionText="descriptionText for radio input"
        />
      </>
    );
  };
  const Radio = () => {
    return (
      <>
        <h3>Radio Group</h3>
        <WpRadioGroup id="one_on_one_count" label="How many 1:1's do you have?" direction="horizontal">
          <WpRadioInput id="1" label="1" value="1" descriptionText="One" />
          <WpRadioInput id="2" label="2" value="2" descriptionText="Two" />
          <WpRadioInput id="3" label="3" value="3" descriptionText="Three" />
          <WpRadioInput id="4" label="4" value="4" descriptionText="Four" />
        </WpRadioGroup>
      </>
    );
  };

  return (
    <>
      <RadioInput />
      <hr />
      <Radio />
      <hr />
      <SelectExample />
      <hr />
      <FormExample />
      <hr />
      <CopyPasteInputExample />
      <hr />
    </>
  );
};

export default FormsDocs;
